import { render } from "./DatenschutzView.vue?vue&type=template&id=31c25b98"
import script from "./DatenschutzView.vue?vue&type=script&lang=js"
export * from "./DatenschutzView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__